module.exports = __webpack_public_path__ + "img/cash-lock.ddd9af0e.svg";